export default "__VITE_ASSET__DfJso_tO__"